import { toLower } from '../string.helpers'

const cleanupXUsername = (str) => {
  return toLower(str?.startsWith('@') ? str?.slice(1) : str)
}

const extractInitials = (firstName, lastName) => {
  return firstName && lastName && `${firstName[0] || ''}${lastName[0] || ''}`
}

export { cleanupXUsername, extractInitials }
